module.exports = __webpack_public_path__ + "static/media/gjhy-v.8441cdfe.png";